import { putV2ApiCompanyIdApprovalWorkflowsWorkflowId } from 'src/client/spendesk-api';

import { type ApiApprovalWorkflow } from '../approvalWorkflow';

type ApiError = {
  errors: Array<{
    type: string;
    message: string;
    path: string[];
  }>;
};

export const editApprovalWorkflow = async ({
  companyId,
  approvalWorkflow,
}: {
  companyId: string;
  approvalWorkflow: ApiApprovalWorkflow;
}): Promise<void> => {
  const { statusCode, body } =
    await putV2ApiCompanyIdApprovalWorkflowsWorkflowId({
      body: approvalWorkflow.definition,
      path: { companyId, workflowId: approvalWorkflow.id },
    });
  if (statusCode !== 200) {
    throw new Error(
      (body as ApiError).errors[0]?.message ||
        'Impossible to edit an approval workflow',
    );
  }
};
